<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style="enable-background: new 0 0 100 100"
    xml:space="preserve"
  >
    <g transform="translate(319.000000, 195.000000)">
      <path
        d="M-269-110c-19.3,0-35-15.7-35-35s15.7-35,35-35s35,15.7,35,35S-249.7-110-269-110z M-269-115.4   c16.3,0,29.6-13.2,29.6-29.6s-13.2-29.6-29.6-29.6s-29.6,13.2-29.6,29.6S-285.3-115.4-269-115.4z M-258.7-147.7   c1.7,0,3.1,1.2,3.1,2.7s-1.4,2.7-3.1,2.7h-20.7c-1.7,0-3.1-1.2-3.1-2.7s1.4-2.7,3.1-2.7H-258.7z"
      ></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "Skip",
};
</script>
